/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { apiGlobalRepairOrder } from '@/api/global';
export default /*#__PURE__*/_defineComponent({
  __name: 'orderRepairDialog',
  props: {
    gid: {
      type: Number,
      default: 0
    }
  },
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const repairVisible = ref(false);
    const repairConfirmLoading = ref(false);
    const formRef = ref();
    const formDetail = ref({
      payType: 0
    });
    const editForm = ref({
      thirdOrder: ''
    });
    const handleCloseRepair = formEl => {
      repairVisible.value = false;
      if (!formEl) return;
      formEl.resetFields();
      editForm.value = {
        thirdOrder: ''
      };
    };
    const handleOk = formEl => {
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          repairConfirmLoading.value = true;
          apiGlobalRepairOrder({
            orderId: formDetail.value.id,
            gid: props.gid,
            thirdOrder: editForm.value.thirdOrder
          }).then(res => {
            if (res.code === 0) {
              handleCloseRepair(formRef.value);
              emits('success');
            }
          }).finally(() => {
            repairConfirmLoading.value = false;
          });
        }
      });
    };
    const show = payload => {
      repairVisible.value = true;
      formDetail.value = payload.data;
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_button = __unplugin_components_3;
      const _component_el_dialog = __unplugin_components_4;
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "补单",
        width: "600px",
        modelValue: _unref(repairVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(repairVisible) ? repairVisible.value = $event : null),
        "before-close": () => handleCloseRepair(_unref(formRef)),
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => handleCloseRepair(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(repairConfirmLoading),
          onClick: _cache[2] || (_cache[2] = $event => handleOk(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: _unref(editForm),
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "第三方订单号",
            prop: "thirdOrder",
            rules: [{
              required: true,
              message: '请输入第三方订单号',
              trigger: 'change'
            }, _unref(formDetail).payType === 1 ? {
              len: 15,
              message: '订单号格式错误(15个字符)',
              trigger: 'change'
            } : {}, _unref(formDetail).payType === 2 ? {
              len: 24,
              message: '订单号格式错误(24个字符)',
              trigger: 'change'
            } : {}]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              placeholder: "输入第三方订单号",
              modelValue: _unref(editForm).thirdOrder,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(editForm).thirdOrder = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "before-close"]);
    };
  }
});